import React from 'react';
import { motion } from 'framer-motion';

const Legal = () => {
  const rows = [
    { label: 'Legal Entity', value: 'SOLIDCORE VENTURE LLP' },
    { label: 'LLPIN', value: 'ACY-0585' },
    { label: 'Legal Status', value: 'Registered Limited Liability Partnership, India.' },
    {
      label: 'Registered Office',
      value: 'Flat No. AMN0101104, 11th Floor, Tower N-10, Jaypee Aman, Sector 151, Noida, Gautam Buddha Nagar, Uttar Pradesh, India – 201301.',
    },
  ];

  return (
    <div style={{ background: 'var(--ink)', minHeight: '100vh' }} data-testid="legal-page">
      {/* Header */}
      <section className="relative overflow-hidden" style={{ padding: '160px 0 70px' }}>
        <div
          className="glow"
          style={{
            width: 700, height: 700, left: '50%', top: -380,
            transform: 'translateX(-50%)',
            background: 'radial-gradient(circle, rgba(70,110,230,0.3), transparent 65%)',
          }}
        />
        <div className="relative max-w-[820px] mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="eyebrow">Legal</span>
            <h1
              style={{
                fontFamily: 'var(--display)',
                fontSize: 'clamp(36px, 5vw, 60px)',
                fontWeight: 900,
                letterSpacing: '-0.03em',
                lineHeight: 1.0,
                color: 'var(--text)',
              }}
            >
              Legal Information
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section
        className="cream"
        style={{ background: 'var(--cream)', color: 'var(--char)', padding: '70px 0 110px' }}
      >
        <div className="max-w-[820px] mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="rounded-[18px] overflow-hidden"
            style={{ background: 'var(--paper)', border: '1px solid #E2D9C7' }}
          >
            {rows.map((row, i) => (
              <div
                key={row.label}
                className="grid sm:grid-cols-[220px_1fr] gap-1 sm:gap-6 px-6 sm:px-8 py-5"
                style={{ borderTop: i === 0 ? 'none' : '1px solid #E2D9C7' }}
              >
                <div
                  className="font-mono"
                  style={{ fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--char-3)', paddingTop: 4 }}
                >
                  {row.label}
                </div>
                <div style={{ fontSize: 16, color: 'var(--char)', lineHeight: 1.65, fontWeight: 500 }}>
                  {row.value}
                </div>
              </div>
            ))}
            <div
              className="grid sm:grid-cols-[220px_1fr] gap-1 sm:gap-6 px-6 sm:px-8 py-5"
              style={{ borderTop: '1px solid #E2D9C7' }}
            >
              <div
                className="font-mono"
                style={{ fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--char-3)', paddingTop: 4 }}
              >
                Official Contact
              </div>
              <div style={{ fontSize: 16, lineHeight: 1.65 }}>
                <a
                  href="mailto:kuzagra@solidcoreventure.com"
                  className="transition-colors"
                  style={{ color: '#A36F12', fontWeight: 600 }}
                  data-testid="legal-email-link"
                >
                  kuzagra@solidcoreventure.com
                </a>
              </div>
            </div>
          </motion.div>

          <p className="mt-8" style={{ fontSize: 13.5, color: 'var(--char-2)' }}>
            See also:{' '}
            <a href="/privacy-policy" style={{ color: '#A36F12', fontWeight: 600 }}>
              Privacy Policy
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Legal;
